var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPinned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_56-Pin",
    "data-name": "56-Pin"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.71 10.29-8-8a1 1 0 0 0 -1.42 0l-1.58 1.59a3 3 0 0 0 -.22 4l-6.63 4.72a5 5 0 0 0 -6.4.55l-2.17 2.14a1 1 0 0 0 0 1.42l12 12a1 1 0 0 0 1.42 0l2.17-2.17a5 5 0 0 0 .55-6.4l4.72-6.63a3 3 0 0 0 4-.22l1.59-1.58a1 1 0 0 0 -.03-1.42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.29 28.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4.88-4.88-1.42-1.42z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPinned);
export default __webpack_public_path__ + "static/media/icon-pinned.3d012d2984547f4b7e5a3f3e04cf2b27.svg";
export { ForwardRef as ReactComponent };